module.exports = __webpack_public_path__ + "img/news-bg.27926c7f.png";